const $ = require('jquery');

jQuery(document).ready(function() {

    var labels = {};

    labels.nl_NL = {
        previousMonth : 'Vorige maand',
        nextMonth     : 'Volgende maand',
        months: [ 'januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december' ],
        monthsShort: [ 'jan', 'feb', 'maa', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec' ],
        weekdays: [ 'zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag' ],
        weekdaysShort: [ 'zo', 'ma', 'di', 'wo', 'do', 'vr', 'za' ],
    };

    labels.en_US = {
        previousMonth : 'Previous month',
        nextMonth     : 'Next month',
        months: [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ],
        monthsShort: [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ],
        weekdays: [ 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday' ],
        weekdaysShort: [ 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat' ],
    };

    labels.de_DE = {
        previousMonth : 'Nächste Monat',
        nextMonth     : 'Früher Monat',
        months: [ 'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember' ],
        monthsShort: [ 'Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez' ],
        weekdays: [ 'Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag' ],
        weekdaysShort: [ 'So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa' ],
    };

    var wp_lang = WPLANG.replace('-', '_');

    var pikaday_i18n = labels[wp_lang] || labels['nl_NL'];

    $('.booking-form').each(function() {
        var $this = $(this);
        var $arrival = $this.find('.arrival-date');
        var $departure = $this.find('.departure-date');

        var start = $this.data('start') || moment().format('YYYYMMDD');
        var min_date = $this.data('min-date') || moment().format('YYYYMMDD');

        var arrival = moment(start, 'YYYYMMDD');
        var has_nights = ($this.data('nights') > 0);
        var nights = (has_nights) ? $this.data('nights') : 1;
        var minDate = moment(min_date, 'YYYYMMDD');
        
        if(arrival.isBefore(minDate)) {
            var departure = minDate.clone().add(nights, 'days');
        } else {
            var departure = arrival.clone().add(nights, 'days');
        }

        var startDate,
            endDate,
            updateStartDate = function(start_date) {
                startDate = start_date;
                endDate = endPicker.getDate();

                if(has_nights) {
                    var end = new Date(startDate.getTime() + (nights * (24 * 60 * 60 * 1000)));

                    endPicker.setMinDate(end);
                    endPicker.setMaxDate(end);

                    endPicker.setDate(end);
                    endPicker.setStartRange(startDate);
                    endPicker.setEndRange(end);

                }
                else {
                    if (startDate > endDate) {
                        endDate = new Date(startDate.getTime() + 24 * 60 * 60 * 1000);
                        endPicker.setDate(endDate);
                        endPicker.setStartRange(startDate);
                        endPicker.setMinDate(startDate);
                    }
                }

                startPicker.setStartRange(startDate);
                startPicker.setEndRange(endDate);
            },
            updateEndDate = function(end_date) {
                endDate = end_date;

                startPicker.setEndRange(endDate);
                endPicker.setEndRange(endDate);
            },
            startField = $(this).find('input[name=arrive]')[0],
            startPicker = new Pikaday({
                format: 'DD/MM/YYYY',
                field: startField,
                firstDay: 1,
                minDate: moment(min_date, 'YYYYMMDD').toDate(),
                defaultDate: arrival.toDate(),
                setDefaultDate: true,
                i18n: pikaday_i18n,
                onSelect: function() {
                    updateStartDate(this.getDate());
                    endPicker.show();
                }
            }),
            endField = $(this).find('input[name=depart]')[0],
            endPicker = new Pikaday({
                format: 'DD/MM/YYYY',
                field: endField,
                firstDay: 1,
                minDate: new Date(),
                defaultDate: departure.toDate(),
                setDefaultDate: true,
                i18n: pikaday_i18n,
                onSelect: function() {
                    updateEndDate(this.getDate());
                }
            });

        updateStartDate(arrival.toDate());
    });

});
